import http from "../http-common";

class SettingsDataService {
        // Returns the bool value of if user wants to get emails or not
        getEmailsStatus(user_id) {
            return http.get(`/settings/${user_id}/emailStatus`);
        }
    
        // changes  disabling or enabling of emails based on user setting for email status for hardware tickets 
        changeEmailsStatus(user_id, data) {
            return http.put(`/settings/${user_id}/updateEmailStatus`, data);
        }
    
        // changes  disabling or enabling of emails based on user setting for email status for software tickets 
        changeSoftwareEmailsStatus(user_id, data) {
            return http.put(`/settings/${user_id}/updateSoftwareEmailStatus`, data);
        }
}


export default new SettingsDataService();
